import {InjectionToken} from '@angular/core';

export const REQ_URL = new InjectionToken<string>('ReqUrl');